export default __webpack_public_path__ + "static/media/3.37f157bd.png";